import React from 'react'
import Card from './card'

const Program = () => {
  return (
    <div className='Program' id='Program'>
      <div className="box">
        <h2 className='h2'>Explore our </h2>
        <h3>Programs</h3>
        <h2 className='h2'>To Shape you</h2>
      </div>
      <Card />
    </div>
  )
}

export default Program